import { getEnv } from './getEnv';

/*
 * - It's important to name your feature flag with the pattern: __FEATURE_<<name-of-the-feature>>__
 * - Also, make sure to give as much input as possible so it's clear for future references and
 *   when to remove the feature flag and/or promote it to feature.
*/
export enum FeatureFlags {
  FeatureDeployments = '__FEATURE_DEPLOYMENTS__',
}

const env = getEnv();
export const featureFlags = {
  [FeatureFlags.FeatureDeployments]: env.qa,
};

export const isFeatureFlagEnabled = (featureFlag: FeatureFlags): boolean => Boolean(featureFlags[featureFlag]);
